import { call, all } from "redux-saga/effects";
import {
  loadIncidentsSaga,
  loadSecurityAlertsLastWeekSaga,
  loadSecurityAlertsLastMonthSaga,
  loadLogsPerDaySaga,
  loadSystemStatusSaga,
  loadDeviceGroupsSaga
} from "./dashboard/sagas";
import { loadLogSourcesSaga } from "./log-sources/sagas";
import { loadOpenIncidentSaga, loadCloseIncidentSaga, addResolutionProposalActionSaga, addCommentSaga } from "./incidents/incidentSagas";
import { loadReportsSaga, downloadReportSaga } from "./reports/sagas";
import { loadCustomerInformationSaga } from "./customer-information/sagas";

export default function* rootSaga() {
  yield all([
    call(loadCustomerInformationSaga),
    call(loadOpenIncidentSaga),
    call(loadCloseIncidentSaga),
    call(loadIncidentsSaga),
    call(addCommentSaga),
    call(addResolutionProposalActionSaga),
    call(loadSecurityAlertsLastWeekSaga),
    call(loadSecurityAlertsLastMonthSaga),
    call(loadLogsPerDaySaga),
    call(loadSystemStatusSaga),
    call(loadLogSourcesSaga),
    call(loadReportsSaga),
    call(downloadReportSaga),
    call(loadDeviceGroupsSaga),
  ]);
}

/* TODO:
    loadIncidentsSaga is for the dashboard
    loadIncidentSaga is for incidentPage and comes from JSON DB server.
    We need better naming convention and some refactoring. 
*/



// WEBPACK FOOTER //
// ./src/saga.js